import { LABELS } from '@/constants/common/message.constants'
import { type MonthlyCustomerReportListExEntity } from '@/libs/api'

/**
 * 請求ステータス（未設定は null。遷移制限なしの手動ラベル管理であり承認ワークフローではない）
 */
export type MonthlyCustomerReportStatus =
  MonthlyCustomerReportListExEntity['status']

export type MonthlyCustomerReportStatusValue =
  NonNullable<MonthlyCustomerReportStatus>

export const MONTHLY_CUSTOMER_REPORT_STATUS = {
  /** 運行実績確定済み */
  TOUR_CONFIRMED: 'TOUR_CONFIRMED',
  /** 一次承認待ち */
  FIRST_APPROVAL_PENDING: 'FIRST_APPROVAL_PENDING',
  /** 一次承認済み */
  FIRST_APPROVED: 'FIRST_APPROVED',
  /** 最終承認済み */
  FINAL_APPROVED: 'FINAL_APPROVED'
} as const satisfies Record<
  MonthlyCustomerReportStatusValue,
  MonthlyCustomerReportStatusValue
>

export const MONTHLY_CUSTOMER_REPORT_STATUS_LABEL: Record<
  MonthlyCustomerReportStatusValue,
  string
> = {
  [MONTHLY_CUSTOMER_REPORT_STATUS.TOUR_CONFIRMED]:
    LABELS.TOUR_CONFIRMED_BILLING_STATUS,
  [MONTHLY_CUSTOMER_REPORT_STATUS.FIRST_APPROVAL_PENDING]:
    LABELS.FIRST_APPROVAL_PENDING_BILLING_STATUS,
  [MONTHLY_CUSTOMER_REPORT_STATUS.FIRST_APPROVED]:
    LABELS.FIRST_APPROVED_BILLING_STATUS,
  [MONTHLY_CUSTOMER_REPORT_STATUS.FINAL_APPROVED]:
    LABELS.FINAL_APPROVED_BILLING_STATUS
}

/**
 * 一覧フィルタ専用: 請求ステータスの絞り込みには未設定「NONE」も選択肢に含める
 * （Issue #3668 本文②、2026-08-03追記で確定）
 */
export type MonthlyCustomerReportStatusFilter =
  | MonthlyCustomerReportStatusValue
  | 'NONE'

export const MONTHLY_CUSTOMER_REPORT_STATUS_FILTER = {
  NONE: 'NONE',
  ...MONTHLY_CUSTOMER_REPORT_STATUS
} as const satisfies Record<
  MonthlyCustomerReportStatusFilter,
  MonthlyCustomerReportStatusFilter
>

export const MONTHLY_CUSTOMER_REPORT_STATUS_FILTER_LABEL: Record<
  MonthlyCustomerReportStatusFilter,
  string
> = {
  NONE: LABELS.BILLING_STATUS_UNSET,
  ...MONTHLY_CUSTOMER_REPORT_STATUS_LABEL
}
